import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Button, Table, Modal } from "react-bootstrap";
import InputField from "./InputFieldEstimates";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import baseURL from "../../../../../Url/NodeBaseURL";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const PaymentDetails = ({
  orderDetails,
  paymentDetails,
  setPaymentDetails,
  saving,
  handleSave,
  handleBack,
  repairDetails,
  setRepairDetails,
  totalPrice,
  schemeSalesData,
  oldSalesData,
  taxableAmount,
  discountAmt,
  totalAmount,
  taxAmount,
  oldItemsAmount,
  schemeAmount,
  netPayableAmount,
  netAmount,
  salesNetAmount,
  salesTaxableAmount,
  salesAmountToPass,
  updatedOldItemsAmount,
  netPayAmount,
  discount,
  handleDiscountChange,
  refreshSalesData,
  offers,
  loading,
  festivalShowModal,
  handleFestivalShowModal,
  handleFestivalCloseModal,
  appliedOffers,
  setAppliedOffers,
  festivalDiscountAmt,
  handleApply,
  isAnyOfferApplied,
  manualNetAmount,
  setManualNetAmount,
  handleManualNetAmountChange,
  isManualNetMode,
  setIsManualNetMode,
  handleManualNetPayAmountChange,
  manualNetPayAmount,
  applyDiscountAmountToRepairDetails,
  estimate_number,
}) => {
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const location = useLocation();
  const [appliedOfferKey, setAppliedOfferKey] = useState(null);
  const [oldItemsSalesAmount, setOldItemsSalesAmount] = useState(0);
  const navigate = useNavigate();
  const [manualNetPayAmountPayment, setManualNetPayAmountPayment] = useState(0);
  const [editedManualNetPayAmountPayment, setEditedManualNetPayAmountPayment] =
    useState(0);
  const [isEdited, setIsEdited] = useState(false);
  const [isEditedNetPayableAmount, setIsEditedNetPayableAmount] =
    useState(false);
  const [isSaveNetPayableAmount, setIsSaveNetPayableAmount] = useState(false);
  const [savedNetPayableAmount, setSavedNetPayableAmount] = useState(0);
  const [roundOffAmount, setRoundOffAmount] = useState(0);
  const netPayableInputRef = useRef(null);

  useEffect(() => {
    setIsSaveNetPayableAmount(false);
    setIsEditedNetPayableAmount(false);
    setIsEdited(false);
  }, [oldItemsAmount, salesAmountToPass, netAmount]);
  useEffect(() => {
    // pull the latest data
    const fetchEstimateDetails = async () => {
      try {
        setManualNetPayAmountPayment(
          netPayableAmount
        );
        setEditedManualNetPayAmountPayment(
          netPayableAmount
        );
      } catch (error) {
        console.error("Error fetching order details:", error);
      }
    };

    fetchEstimateDetails();
  }, [repairDetails, oldItemsAmount, salesAmountToPass]);

  let rounded = Math.round(
    isSaveNetPayableAmount
      ? savedNetPayableAmount
      : manualNetPayAmountPayment
  );
  // call api to get old items amount
  useEffect(() => {
    const fetchOldItems = async () => {
      console.log("fetchOldItems called", estimate_number);
      if (estimate_number) {
        console.log("estimate_number", estimate_number);
        const response = await axios.get(
          `${baseURL}/get/olditems/${estimate_number}`
        );
        console.log("response.data", response.data);
        setOldItemsSalesAmount(
          response.data.reduce(
            (sum, item) => sum + parseFloat(item.total_amount || 0),
            0
          )
        );
        setManualNetPayAmountPayment(
          netPayableAmount - oldItemsSalesAmount
        );
        setEditedManualNetPayAmountPayment(
          netPayableAmount - oldItemsSalesAmount
        );
      }
    };
    fetchOldItems();
  }, [estimate_number]);

  useEffect(() => {
    const storedPaymentDetails =
      JSON.parse(localStorage.getItem(`paymentDetails`)) || {};

    const cashAmount =
      location.state?.cash_amount ??
      storedPaymentDetails.cash_amount ??
      rounded;

    const cardAmt =
      location.state?.card_amt ?? storedPaymentDetails.card_amt ?? 0;

    const chqAmt = location.state?.chq_amt ?? storedPaymentDetails.chq_amt ?? 0;

    const onlineAmt =
      location.state?.online_amt ?? storedPaymentDetails.online_amt ?? 0;

    // Only update if paymentDetails has not been manually updated
    console.log("paymentdetails saved 1");
    if (!isSaveNetPayableAmount) {
      setPaymentDetails({
        cash_amount: cashAmount,
        card_amt: cardAmt,
        chq_amt: chqAmt,
        online_amt: onlineAmt,
      });
    }
    console.log("saved paymentDetails 2", paymentDetails);
  }, [location.state, rounded, isSaveNetPayableAmount]);
  const handleNew = () => {
    setIsSaveNetPayableAmount(false);
    setIsEditedNetPayableAmount(false);
    setIsEdited(false);
    setRoundOffAmount(0);
    setSavedNetPayableAmount('');
    setEditedManualNetPayAmountPayment('');
    setManualNetPayAmountPayment(0);
    const uniqueTimestamp = Date.now();
    localStorage.clear();
    navigate(`/estimates?reset=true&t=${uniqueTimestamp}`);
    window.location.reload();
  };

  useEffect(() => {
    // Only update if cash_amount is NOT provided from location.state
    console.log("rounded", rounded);
    if (rounded && location.state?.cash_amount === undefined) {
      console.log("paymentdetails saved 2");
      setPaymentDetails((prev) => {
        const updatedDetails = {
          ...prev,
          online_amt: parseFloat(rounded), // Fixed to two decimal places
        };
        setPaymentDetails(updatedDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedDetails)
        );
        return updatedDetails;
      });
      console.log("saved paymentDetails 3", paymentDetails);
    }
  }, [rounded, location.state]);

  useEffect(() => {
    // Sum of all payment details
    const totalEnteredAmount =
      parseFloat(paymentDetails.cash_amount || 0) +
      parseFloat(paymentDetails.card_amt || 0) +
      parseFloat(paymentDetails.chq_amt || 0) +
      parseFloat(paymentDetails.online_amt || 0);

    const tolerance = 0.01; // Small tolerance for floating point precision issues

    setIsSubmitEnabled(
      Math.abs(totalEnteredAmount - parseFloat(totalPrice || 0)) < tolerance
    );
  }, [paymentDetails, totalPrice]);

  // useEffect(() => {
  //   if (!isEditedNetPayableAmount && netPayableInputRef.current) {
  //     netPayableInputRef.current.focus();
  //   }
  // }, [isEditedNetPayableAmount]);

  useEffect(() => {
    const storedPaymentDetails =
      JSON.parse(localStorage.getItem(`paymentDetails`)) || {};

    const cashAmount =
      location.state?.cash_amount ??
      storedPaymentDetails.cash_amount ??
      rounded;

    const cardAmt =
      location.state?.card_amt ?? storedPaymentDetails.card_amt ?? 0;

    const chqAmt = location.state?.chq_amt ?? storedPaymentDetails.chq_amt ?? 0;

    const onlineAmt =
      location.state?.online_amt ?? storedPaymentDetails.online_amt ?? 0;

    // Only update if paymentDetails has not been manually updated
    console.log("paymentdetails saved 1");
    if (!isSaveNetPayableAmount) {
      setPaymentDetails({
        cash_amount: cashAmount,
        card_amt: cardAmt,
        chq_amt: chqAmt,
        online_amt: onlineAmt,
      });
      console.log("saved paymentDetails 4", onlineAmt);
    }
  }, [location.state, rounded, isSaveNetPayableAmount]);

  const handlePaymentChange = (field, value) => {
    console.log("=== handlePaymentChange started ===");
    console.log("Input field:", field);
    console.log("Input value:", value);

    // Parse and validate input value
    const newValue = parseFloat(value) || 0;
    console.log("Parsed new value:", newValue);

    // Get current payment details
    const currentOnlineAmount = parseFloat(paymentDetails.online_amt || 0);
    const oldValue = parseFloat(paymentDetails[field] || 0);
    console.log("Current online amount:", currentOnlineAmount);
    console.log("Old value for field:", oldValue);

    // Calculate field difference
    const fieldDifference = newValue - oldValue;
    console.log("Field difference:", fieldDifference);

    // Prepare updated payment details
    let updatedDetails = { ...paymentDetails };

    if (field !== "online_amt") {
      console.log("Processing non-online payment field");
      const newOnlineAmount = Math.max(
        currentOnlineAmount - fieldDifference,
        0
      );
      console.log("New online amount calculated:", newOnlineAmount);

      updatedDetails = {
        ...paymentDetails,
        [field]: newValue,
        online_amt: newOnlineAmount,
      };
    } else {
      console.log("Processing online payment field");
      updatedDetails = {
        ...paymentDetails,
        online_amt: newValue,
      };
    }

    // Get the current max amount based on the latest state
    const currentMaxAmount = isSaveNetPayableAmount
      ? savedNetPayableAmount
      : manualNetPayAmountPayment;

    console.log("=== Amount Details ===");
    console.log("Max Amount:", currentMaxAmount);
    console.log("Total Amount:", newValue);

    // Simple comparison without tolerance
    if (newValue > currentMaxAmount) {
      console.log("Error: Amount exceeds maximum allowed");
      console.log("Difference:", newValue - currentMaxAmount);
      alert("Total payment amount cannot exceed Net Payable Amount.");
      return;
    }

    // Update state and storage
    console.log("Updating payment details:", updatedDetails);
    console.log("paymentdetails saved 3");
    setPaymentDetails(updatedDetails);
    console.log("saved paymentDetails 4", updatedDetails);
    localStorage.setItem(
      `paymentDetails`,
      JSON.stringify(updatedDetails)
    );
    console.log("=== handlePaymentChange completed ===");
  };

  const handleClose = () => {
    // navigate(`/sales?tabId=${tabId}`);
    navigate(-1);
  };

  const handleSaveNetPayableAmount = () => {

    // Handle empty string or minus sign case
    if (editedManualNetPayAmountPayment === '' || editedManualNetPayAmountPayment === '-') {
      alert("Please enter a valid net payable amount.");
      return;
    }

    const newNetPayableAmount = parseFloat(editedManualNetPayAmountPayment);
    const difference = manualNetPayAmountPayment + discountAmt - newNetPayableAmount;
    const newRoundOff = Math.round(difference);

    // Prevent negative discount
    if(newRoundOff < 0) {
      alert("Discount cannot be negative. Please enter a valid amount.");
      return;
    }
    // Update the state
    setRoundOffAmount(newRoundOff);
    // setRoundOffAmountForSaveRepairsApiCall(newRoundOff);
    setEditedManualNetPayAmountPayment(newNetPayableAmount);
    setManualNetPayAmountPayment(newNetPayableAmount);
    setIsEditedNetPayableAmount(true);
    setIsSaveNetPayableAmount(true);
    setSavedNetPayableAmount(newNetPayableAmount);

    // Apply the discount amount (this will convert to percentage internally)
    applyDiscountAmountToRepairDetails(newRoundOff);

    // Use the new values directly instead of waiting for state update
    const updatedPaymentDetails = {
      ...paymentDetails,
      online_amt: newNetPayableAmount,
    };

    // Update payment details directly
    setPaymentDetails(updatedPaymentDetails);
    localStorage.setItem(
      `paymentDetails`,
      JSON.stringify(updatedPaymentDetails)
    );
  };

  const handleEdit = (amount) => {
    if (isEditedNetPayableAmount) {
      setIsEditedNetPayableAmount(false);
    } else {
      setIsEditedNetPayableAmount(true);
    }
  };

  return (
    <>
      <div>
        <Col className="sales-form-section">
          <Row>
            <h4 className="mb-3" style={{ fontSize: "20px" }}>
              Summary
            </h4>
            {/* <div style={{ maxHeight: "140px", overflowY: "auto" }}> */}
            <Table bordered hover responsive>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Total Amount
                </td>
                <td colSpan="4">{totalAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="12" className="text-right">
                  Discount Amounts
                </td>
                <td colSpan="4">
                  {" "}
                  @
                  <input
                    type="number"
                    value={ discount ? discount.toFixed(2) : 0}
                    onChange={handleDiscountChange}
                    max="100"
                    min="0"
                    step="0.01"
                    style={{ width: "70px", padding: "2px", fontSize: "13px" }}
                  />
                </td>
                <td colSpan="4">{discountAmt.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="12" className="text-right">
                  Festival Offer
                </td>
                <td colSpan="4"> &ensp;&ensp;</td>

                <td colSpan="4">
                  {festivalDiscountAmt.toFixed(2)}
                  <Button
                    onClick={handleFestivalShowModal}
                    style={{
                      display: "none",
                      backgroundColor: "#a36e29",
                      borderColor: "#a36e29",
                      fontSize: "12px",
                      padding: "2px 8px",
                      marginLeft: "10px",
                    }}
                    size="sm"
                  >
                    Apply Offer
                  </Button>
                </td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Taxable Amount
                </td>
                <td colSpan="4">{taxableAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Tax Amount
                </td>
                <td colSpan="4">{taxAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Net Amount
                </td>
                <td colSpan="4">{netAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Old Items Amount
                </td>
                <td colSpan="4">{oldItemsAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Scheme Amount
                </td>
                <td colSpan="4">{schemeAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Sale Return Amount
                </td>
                {/* <td colSpan="4">{salesNetAmount.toFixed(2)}</td> */}
                <td colSpan="4">{salesAmountToPass.toFixed(2)}</td>
              </tr>

              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Net Payable Amount
                </td>
                {isEditedNetPayableAmount ? (
                  <td colSpan="4">
                    {isSaveNetPayableAmount
                      ? (savedNetPayableAmount === '' || savedNetPayableAmount === '-' ? savedNetPayableAmount : Math.round(savedNetPayableAmount).toFixed(2))
                      : (editedManualNetPayAmountPayment === '' || editedManualNetPayAmountPayment === '-' ? editedManualNetPayAmountPayment : Math.round(editedManualNetPayAmountPayment).toFixed(2))}
                    <FontAwesomeIcon
                      icon={faPencil}
                      onClick={() => handleEdit()}
                      style={{
                        cursor: "pointer",
                        color: "black",
                        backgroundColor: "transparent",
                      }}
                    />
                  </td>
                ) : (
                  <td colSpan="4">
                    <input
                      ref={netPayableInputRef}
                      type="number"
                      style={{
                        width: "100px",
                        padding: "5px",
                        fontSize: "13px",
                      }}
                      value={
                        isSaveNetPayableAmount
                          ? (savedNetPayableAmount === '' || savedNetPayableAmount === '-' ? savedNetPayableAmount : Math.round(savedNetPayableAmount))
                          : (editedManualNetPayAmountPayment === '' || editedManualNetPayAmountPayment === '-' ? editedManualNetPayAmountPayment : Math.round(editedManualNetPayAmountPayment))
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        
                        // Allow empty input for backspace/clearing
                        if (inputValue === '' || inputValue === null) {
                          if (isSaveNetPayableAmount) {
                            setSavedNetPayableAmount('');
                            setEditedManualNetPayAmountPayment('');
                          } else {
                            setEditedManualNetPayAmountPayment('');
                          }
                          return;
                        }
                        
                        // Allow minus sign for negative numbers
                        if (inputValue === '-') {
                          if (isSaveNetPayableAmount) {
                            setSavedNetPayableAmount('-');
                            setEditedManualNetPayAmountPayment('-');
                          } else {
                            setEditedManualNetPayAmountPayment('-');
                          }
                          return;
                        }
                        
                        // For any other input, try to parse as number
                        const newValue = parseFloat(inputValue);
                        
                        // Check if it's a valid number (including negative numbers)
                        if (isNaN(newValue)) {
                          return; // Don't update if it's not a valid number
                        }
                        
                        // Round the value
                        const roundedValue = Math.round(newValue);
                        
                        // If the value is already saved, allow editing without validation
                        if (isSaveNetPayableAmount) {
                          setSavedNetPayableAmount(roundedValue);
                          setEditedManualNetPayAmountPayment(roundedValue);
                          return;
                        }
                        
                        // Update the value
                        setEditedManualNetPayAmountPayment(roundedValue);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSaveNetPayableAmount();
                        }
                      }}
                    />
                    <Link onClick={() => handleSaveNetPayableAmount()}>
                      Save
                    </Link>
                  </td>
                )}
              </tr>
            </Table>
          </Row>
        </Col>

        <Col className="sales-form-section d-none">
          <Row>
            <h4 className="mb-3" style={{ fontSize: "18px" }}>
              Payment Details
            </h4>
            <Col xs={12} md={4}>
              <InputField
                label="Online Amt"
                name="online_amt"
                value={paymentDetails.online_amt}
                onChange={(e) =>
                  handlePaymentChange("online_amt", e.target.value)
                }
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Card Amt"
                name="card_amt"
                value={paymentDetails.card_amt}
                onChange={(e) =>
                  handlePaymentChange("card_amt", e.target.value)
                }
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Cheque Amt"
                name="chq_amt"
                value={paymentDetails.chq_amt}
                onChange={(e) => handlePaymentChange("chq_amt", e.target.value)}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Cash Amt"
                name="cash_amount"
                value={paymentDetails.cash_amount}
                onChange={(e) =>
                  handlePaymentChange("cash_amount", e.target.value)
                }
              />
            </Col>
            <Col xs={12} md={3}>
              <Button
                onClick={handleSave}
                style={{
                  backgroundColor: "#a36e29",
                  borderColor: "#a36e29",
                  fontSize: "14px",
                  marginTop: "3px",
                  padding: "4px 8px",
                }}
              >
                Save
              </Button>
            </Col>
            <Col xs={12} md={2} className="d-none">
              <Button
                variant="secondary"
                onClick={handleBack}
                style={{
                  backgroundColor: "gray",
                  marginLeft: "-62px",
                  fontSize: "14px",
                  marginTop: "3px",
                  padding: "4px 8px",
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs={12} md={2}>
              <Button
                onClick={handleClose}
                style={{
                  backgroundColor: "gray",
                  borderColor: "gray",
                  marginLeft: "-57px",
                  marginTop: "px",
                  padding: "4px 10px",
                  fontSize: "14px",
                }}
                // disabled={!isSubmitEnabled}
              >
                Close
              </Button>
            </Col>
          </Row>
        </Col>
        <Row className="align-items-center mt-2">
          <Col xs={12} md="auto">
            <Button
              onClick={handleSave}
              disabled={saving}
              style={{
                backgroundColor: "#a36e29",
                borderColor: "#a36e29",
                fontSize: "14px",
                padding: "4px 8px",
              }}
            >
              {saving ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Saving...
                </>
              ) : (
                "Save and Print"
              )}
            </Button>
          </Col>

          <Col xs={12} md="auto">
            <Button
              onClick={() => {
                console.log("Generating sales from estimate:", estimate_number);
                
                // Navigate to sales page with the estimate number to auto-select
                navigate("/sales", {
                  state: {
                    fromEstimate: true,
                    estimateNumber: estimate_number, // Pass the estimate number to auto-select
                  },
                });
              }}
              style={{
                backgroundColor: "gray",
                borderColor: "gray",
                fontSize: "14px",
                padding: "4px 10px",
              }}
            >
              Generate Sales
            </Button>
          </Col>

          {/* <Col xs={12} md="auto">
            <Button
              variant="secondary"
              onClick={handleBack}
              style={{
                backgroundColor: "gray",
                fontSize: "14px",
                padding: "4px 8px",
              }}
            >
              Cancel
            </Button>
          </Col> */}

          <Col xs={12} md="auto">
            <Button
              onClick={handleClose}
              style={{
                backgroundColor: "gray",
                borderColor: "gray",
                fontSize: "14px",
                padding: "4px 10px",
              }}
            >
              Close
            </Button>
          </Col>

          <Col xs={12} md="auto">
            <Button
              onClick={handleNew}
              style={{
                backgroundColor: "gray",
                borderColor: "gray",
                //backgroundColor: "#28a745",
                //borderColor: "#28a745",
                fontSize: "14px",
                padding: "4px 10px",
              }}
            >
              New
            </Button>
          </Col>
        </Row>
      </div>

      <Modal
        show={festivalShowModal}
        onHide={handleFestivalCloseModal}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Available Offers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <p>Loading offers...</p>
          ) : offers.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S No</th>
                  <th>Offer Name</th>
                  <th>Discount On Rate</th>
                  <th>Discount % on MC</th>
                  <th>Discount % for Fixed</th>
                  <th>Valid From</th>
                  <th>Valid To</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {offers.map((offer, index) => {
                  const offerKey = `${offer._id}_${index}`;
                  const isApplied = appliedOffers[offerKey] || false;

                  const formatDate = (dateStr) => {
                    const date = new Date(dateStr);
                    return `${date.getDate().toString().padStart(2, "0")}-${(
                      date.getMonth() + 1
                    )
                      .toString()
                      .padStart(2, "0")}-${date.getFullYear()}`;
                  };

                  return (
                    <tr key={offer._id}>
                      <td>{index + 1}</td>
                      <td>{offer.offer_name}</td>
                      <td>{offer.discount_on_rate}</td>
                      <td>{offer.discount_percentage}</td>
                      <td>{offer.discount_percent_fixed}</td>
                      <td>{formatDate(offer.valid_from)}</td>
                      <td>{formatDate(offer.valid_to)}</td>
                      <td>
                        <Button
                          variant={isApplied ? "danger" : "success"}
                          size="sm"
                          onClick={() => handleApply(offer, index)}
                        >
                          {isApplied ? "Unapply" : "Apply"}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <p>No offers available at the moment.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleFestivalCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PaymentDetails;
